var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex w-full"},[_c('line-chart',{style:({ width: '100%' }),attrs:{"chart-data":_vm.data,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }